import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import DoarModal from '../layout/DoarModal';

const OfertarButton = ({ className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className={`flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-gray-900 px-7 py-3.5 rounded-xl text-base font-bold transition-all duration-200 shadow-lg shadow-yellow-500/20 hover:shadow-yellow-400/30 hover:-translate-y-0.5 ${className}`}
      >
        Ofertar com amor <FontAwesomeIcon icon={faHeart} className="text-sm" />
      </button>
      <DoarModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default OfertarButton;
